    export type IGetCompletedCallback = (xmlHttpRequest: XMLHttpRequest) => void;

    // TODO: Turn into standard async fetch call and delete from bundle.
    export class HttpRequest {

        public static PostJson(url: string, data: string, successCallback?: Function, failCallback?: Function, antiForgeryToken?: string): void {
            HttpRequest.MakePost(url, data, 'application/json; charset=utf-8', successCallback, failCallback, antiForgeryToken);
        }

        public static Post(url: string, data: string, successCallback?: Function, failCallback?: Function, antiForgeryToken?: string): void {
            HttpRequest.MakePost(url, data, 'application/x-www-form-urlencoded', successCallback, failCallback, antiForgeryToken);
        }

        public static Get(url: string, responseType: XMLHttpRequestResponseType, successCallback?: IGetCompletedCallback, failCallback?: Function): void {
            let request = new XMLHttpRequest();

            request.open("GET", url, true);
            request.onreadystatechange = function () {
                if (request.readyState == 4) {
                    if (request.status == 200) {
                        if (successCallback) {
                            successCallback(request);
                        }
                    }
                    else if (failCallback) {
                        failCallback();
                    }
                }
            }

            request.responseType = responseType;

            request.onerror = function () {
                if (failCallback) {
                    failCallback();
                }
            };

            request.send();
        }

        private static MakePost(url: string, data: string, contentType: string, successCallback?: Function, failCallback?: Function, antiForgeryToken?: string): void
        {
            let request = new XMLHttpRequest();

            request.open('POST', url, true);
            request.setRequestHeader('Content-type', contentType);
            request.onreadystatechange = function () {
                if (request.readyState == 4) {
                    if (request.status == 200) {
                        if (successCallback) {
                            successCallback(request.responseText);
                        }
                    }
                    else if (failCallback) {
                        failCallback();
                    }
                }
            }

            if (antiForgeryToken) {
                request.setRequestHeader("__RequestVerificationToken", antiForgeryToken);
            }

            request.onerror = function () {
                if (failCallback) {
                    failCallback();
                }
            };

            request.send(data);
        }
    }
